import React, { Component } from "react";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";

//import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
import { calculatePrice } from "../pricing/calculatePrice";
import SwissPriceTable from "./common/SwissPriceTable";
import CustomerInfoTable from "./common/CustomerInfoTable";
import CustomerInfoTableSwiss from "./common/CustomerInfoTable_swiss";
import CarDentLogTable from "../carbodyparts/CarDentLogTable";
import RequestLoader from "../spinner";
import { connect } from "react-redux";
import { updateJsonData } from "../redux/actions/updateJsonData";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class TabView extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: "",
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    swissTable: [],
    // fullData:[],
    isTableUpdated: false,
    loading:false,
    Authorized: false,
    words : {},
    lang: "",
    jsonData : {}
  };
  count = [];
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
  }
  static getDerivedStateFromProps(props, state){
    // for getting initial values for Authorized from json
    if (props.jsonData) {
      return {
        Authorized: props.jsonData.Authorized,
      }
    } else {
      return null
    }
  }
  getData = async(selectedFile) => {
    Axios.get(
        `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
      ).then((r) => {
        if(r.data.Authorized){
          this.setState({
            Authorized: r.data.Authorized,
            jsonData : r.data
          })
        }else{
            this.setState({
              Authorized: false,
              jsonData : r.data
            })
        }
      }).catch(error=>alert('An error occured please try again'));
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
    }
  };

  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      } else {
        // alert('Data not available.')
      }
    } else {
      this.props.history.push("/login");
    }
  };
  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    for (let i = 0; i < rowArray.length; i++) {
      // if (rowArray[i].Amount) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      //promises.push(url);
      promises.push(Axios.get(url));
      // }
    }

    const arrRes = await Axios.all(promises);

    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");

      // let gtt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //   if (val2 && parseInt(val2) > 25) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }

      // });
      // let ltt = val.map(r => {
      //   let val2 = r.split(" ")[3];

      //  if (val2 && parseInt(val2) < 26) {
      //     ltcount = ltcount + 1;
      //     return val2;
      //   }
      //   //return val2;
      // });

      // return { part: result.data.part,count:val.length-1, lt25: ltt.filter( Boolean ).length, gt25: gtt.filter( Boolean ).length };

      val.map((r) => {
        let val2 = r.split(" ")[3];

        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });

      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
    console.table(ltgtdata);
    //return 5
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      //let dd = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      //  let countRow = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");

    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };

  authorize = () =>{
    /*
    const url = configuration.generatePDF;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    document.getElementById("updateTable").click(); //for triggering updateTable button

    this.setState({
      loading:true
    })
    setTimeout(()=>{
      Axios.post(url, {
        partnerId,
        vin }).then((res) => {
        this.setState({
          loading:false
        })
        Toast.fire({
          type: "success",
          title: "PDF generated successfully!",
        });
      }).catch((err)=>{
        this.setState({
          loading:false
        })
        alert(err)
      })
    },4000)
    */
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const url1 =
    configuration.PostEditorChanges +
    `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${false}`;

    this.setState({
      loading:true
    })
    let authorizedJson = this.props.jsonData;
    authorizedJson.Authorized = true;
    
    Axios.post(url1, this.props.jsonData).then((res) => {
      // alert("table data saved");
      const url = configuration.generatePDF;
      Axios.post(url, {
        partnerId,
        vin
      }).then((res) => {
        this.setState({
          loading:false,
          Authorized:true, //for updating local state instantly
        })
        Toast.fire({
          type: "success",
          title: "PDF generated successfully!",
        });
        // alert("data updated");
      }).catch(err=>{
        this.setState({
          loading:false
        })
        alert("pdf generate failed");
      });
    }).catch(err=>{
      this.setState({
        loading:false
      })
      alert("Table update failed");
    });
    
  }

  getUpdatedStateFromPriceTable = (isTableUpdated) =>{
    this.setState({
      isTableUpdated:isTableUpdated
    })
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  render() {
    //const selectedFile = localStorage.getItem("selectedFile");

    const { orderNumber } = this.state.order;

    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult && 
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    //const dentInfo = scanResult.resultTXT;
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    return (
      <div className="animated fadeIn">
        <Col xs="12" sm="12">
          <Card>
            <CardHeader>
              {/* <button className={`glass btn btn-lg ${this.state.Authorized ? 'btn-success' : 'btn-danger'} pull-right mr-1`} onClick={this.authorize} style={{cursor : "no-drop"}} disabled>
                <i className="fa fa-print" />
                &nbsp; {this.lang("Authorize PDF")}
              </button> */}
              {this.state.loading &&
                <div style={{
                  position: "absolute",
                  left: '75%',
                  top:'0'
                }}>
                <RequestLoader
                  size="60px"
                  style={{ marginLeft: "24px" }} 
                  />
                </div>
              }
              
              {/* <Link className="glass" to="/ReportMini">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link> */}
              <small className="pull-right rightLbl">
                {/* Order No : {orderNumber} */}
              </small>
              <small>
                {" "}
                {this.lang("VIN Number")} : {localStorage.getItem("selectedFile")} &nbsp;
              </small>
            </CardHeader>
            <CardBody>
              <div className="row">
              {/* <CustomerInfoTable /> */}
                {localStorage.getItem("client") == "SWISS" ? (
                  <CustomerInfoTableSwiss viewType='TabView' Authorized={this.state.Authorized}/>
                ) : (
                    <CustomerInfoTable />
                  )}
                <SwissPriceTable
                  vinfolderList={this.state.swissTableCH}
                  viewType="TabView" 
                  getUpdatedStateFromPriceTable = {(data)=>this.getUpdatedStateFromPriceTable(data)}
                />
                {/* <CarDentLogTable /> */}
              </div>
            </CardBody>

            <div className="card-footer">
              {/* <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  this.Update();
                }}
              >
                Update
              </button> */}

              {/* <Link className="glass" to="/ReportMini">
                <button className="btn btn-danger btn-sm pull-right">
                  <i className="fa fa-dot-circle-o"></i> {">>"}
                </button>
              </Link>

              <Link className="glass" to="/vehicleDentInfo">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-right"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link> */}
            </div>
          </Card>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    jsonData : props.jsonData
  };
};
export default connect(mapStateToProps,{
  updateJsonData
})(TabView);

